import IconSvg from 'core/_legacy/icons/IconSvg'

const VisaLogo = () => (
  <IconSvg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="#555"
  >
    <g id="surface1">
      <path
        d="M 45 35 C 45 37.210938 43.210938 39 41 39 L 7 39 C 4.789063 39 3 37.210938 3 35 L 3 13 C 3 10.789063 4.789063 9 7 9 L 41 9 C 43.210938 9 45 10.789063 45 13 Z"
        fill="#1565c0"
      />
      <path
        d="M 15.1875 19 L 12.558594 26.832031 C 12.558594 26.832031 11.894531 23.519531 11.828125 23.101563 C 10.332031 19.691406 8.125 19.882813 8.125 19.882813 L 10.726563 30 L 10.726563 29.996094 L 13.886719 29.996094 L 18.257813 19 Z"
        fill="#fff"
      />
      <path
        d="M 17.6875 30 L 20.558594 30 L 22.296875 19 L 19.390625 19 Z"
        fill="#fff"
      />
      <path
        d="M 38.007813 19 L 34.988281 19 L 30.277344 30 L 33.128906 30 L 33.71875 28.429688 L 37.3125 28.429688 L 37.617188 30 L 40.230469 30 Z M 34.511719 26.328125 L 36.074219 22.171875 L 36.894531 26.328125 Z"
        fill="#fff"
      />
      <path
        d="M 26.367188 22.207031 C 26.367188 21.601563 26.867188 21.148438 28.296875 21.148438 C 29.222656 21.148438 30.285156 21.824219 30.285156 21.824219 L 30.753906 19.515625 C 30.753906 19.515625 29.394531 19 28.0625 19 C 25.042969 19 23.484375 20.441406 23.484375 22.269531 C 23.484375 25.578125 27.464844 25.125 27.464844 26.820313 C 27.464844 27.113281 27.234375 27.785156 25.574219 27.785156 C 23.914063 27.785156 22.816406 27.175781 22.816406 27.175781 L 22.320313 29.394531 C 22.320313 29.394531 23.386719 30 25.4375 30 C 27.496094 30 30.355469 28.460938 30.355469 26.246094 C 30.355469 23.585938 26.367188 23.394531 26.367188 22.207031 Z"
        fill="#fff"
      />
      <path
        d="M 12.210938 24.945313 L 11.246094 20.195313 C 11.246094 20.195313 10.808594 19.167969 9.671875 19.167969 C 8.535156 19.167969 5.234375 19.167969 5.234375 19.167969 C 5.234375 19.167969 10.894531 20.839844 12.210938 24.945313 Z"
        fill="#ffc107"
      />
    </g>
  </IconSvg>
)

export default VisaLogo
